function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.67012 0H14.3401C17.7301 0 20.0001 2.38 20.0001 5.92V14.091C20.0001 17.62 17.7301 20 14.3401 20H5.67012C2.28012 20 0.00012207 17.62 0.00012207 14.091V5.92C0.00012207 2.38 2.28012 0 5.67012 0ZM9.43012 12.99L14.1801 8.24C14.5201 7.9 14.5201 7.35 14.1801 7C13.8401 6.66 13.2801 6.66 12.9401 7L8.81012 11.13L7.06012 9.38C6.72012 9.04 6.16012 9.04 5.82012 9.38C5.48012 9.72 5.48012 10.27 5.82012 10.62L8.20012 12.99C8.37012 13.16 8.59012 13.24 8.81012 13.24C9.04012 13.24 9.26012 13.16 9.43012 12.99Z",
  fill: "#26AA76"
});

function SvgSuccessTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/SuccessTick.f2038e1c.svg";
export { ForwardRef as ReactComponent };